import { useEffect } from "react"
import { downloadRegistry } from "connected-components/dashboard/context/download-registry"
import { usePanelId } from "connected-components/dashboard/context/panel-id"
import type { DownloadDataRegistration } from "connected-components/dashboard/context/download-registry"

/**
 * Registers download data with the dashboard download registry.
 * Uses panel ID from context (provided by PanelIdProvider in dashboard panels).
 * Unregisters on unmount.
 *
 * @param registration - Download data registration (key, sheetName, getData, combineWithOthers)
 */
export function useRegisterDownloadData(registration: DownloadDataRegistration | DownloadDataRegistration[] | null): void {
  const panelId = usePanelId()

  useEffect(() => {
    if (!panelId || !registration) return
    const downloadRegistration = Array.isArray(registration) ? registration : [registration]

    downloadRegistration.forEach(reg => {
      downloadRegistry.register(panelId, reg)
    })

    return () => {
      downloadRegistration.forEach(reg => {
        downloadRegistry.unregister(panelId, reg.key)
      })
    }
  }, [panelId, registration])
}
